<mat-expansion-panel
  #executionPanel="matExpansionPanel"
  class="cta-expansion-panel"
  [expanded]="isPanelExpanded()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title class="!mr-0 !min-w-0 !flex-[1_1_auto] items-center">
      <div class="flex min-w-0 items-center gap-3 pl-1">
        @if (executionTypeRaw() === EExecutionType.unique && executionValue().executionDate) {
          <span class="whitespace-nowrap text-sm font-bold">
            {{ executionValue().executionDate | date: 'EEEE, dd.MM.yyyy' }}
            @if (executionValue().executionTime) {
              <span>, {{ executionValue().executionTime | date: 'HH:mm' }}</span>
            }
          </span>
        }

        @if (executionTypeRaw() === EExecutionType.undesignated) {
          <span class="whitespace-nowrap text-sm font-bold">
            {{
              'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypes.undesignated'
                | translate: { count: executionValue().executionCountTarget ?? 0 }
            }}
          </span>
        }

        @if (executionTypeRaw() === EExecutionType.timeFrame) {
          <span class="whitespace-nowrap text-sm font-bold">
            {{
              'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypes.timeFrame'
                | translate
                  : {
                      count: executionValue().executionCountTarget ?? 1,
                      start: executionValue().executionStartDate | date: 'dd.MM.yyyy, HH:mm',
                      end: executionValue().executionEndDate | date: 'dd.MM.yyyy, HH:mm',
                    }
            }}
          </span>
        }

        @if (executionTypeRaw() === EExecutionType.always) {
          <span class="whitespace-nowrap text-sm font-bold">
            {{
              'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypes.always'
                | translate
            }}
          </span>
        }

        <span class="shrink-0 text-sm whitespace-nowrap text-shikenso-purple-base-60">
          {{ targetsSetLabelTranslationKey() | translate: { count: targetsSetCount() } }}
        </span>
      </div>
    </mat-panel-title>

    <mat-panel-description class="!mr-4 !ml-3 !flex-none !basis-auto !w-auto items-center justify-end">
      <span class="whitespace-nowrap text-sm">{{ targetValuesActionTranslationKey() | translate }}</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="custom-form">
    <app-expected-kpi-list
      [form]="expectedKpisForm()"
      [executionId]="executionId()"
      [platformFeature]="platformFeature()"
      [availableKpis]="availableKpis()"
      [creatorId]="creatorId()!"
      [ctaTemplateId]="ctaTemplateId()"
      [isCustomMode]="isCustomMode()"
      [creators]="creators()"
      [isParentDeleteDisabled]="isDisabled()"
      [isViewMode]="isViewMode()"
    />
  </div>
</mat-expansion-panel>
